import { WhitelabelConfig } from '@whitelabel/types';

const CitiWhitelabelConfig: WhitelabelConfig = {
    displayName: 'Citi',
};

export default CitiWhitelabelConfig;
